import translate from "src/lib/translate";

export {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH
} from "@9amhealth/shared/src/lib/zod";

type validationRecord = {
  error?: string;
};

export const FIRST_NAME_SCHEMA_MESSAGES: validationRecord = {
  error: translate("first_name_required")
};

export const LAST_NAME_SCHEMA_MESSAGES: validationRecord = {
  error: translate("last_name_required")
};

export const STREET_ADDRESS_SCHEMA_MESSAGES: validationRecord = {
  error: translate("street_address_required")
};

export const CITY_SCHEMA_MESSAGES: validationRecord = {
  error: translate("city_required")
};

export const SEX_SCHEMA_MESSAGES: validationRecord = {
  error: translate("sex_required")
};

export const ZIP_CODE_SCHEMA_MESSAGES: validationRecord = {
  error: translate("zip_required")
};

export const STATE_SCHEMA_MESSAGES: validationRecord = {
  error: translate("state_required")
};
